'use client'

import * as Sentry from '@sentry/nextjs'
import { catchError, type ErrorInfo } from 'next/error'
import React from 'react'

// NOTE: LoginDialog renders in the root layout, which app/error.tsx does not cover — an error there
// bubbles to global-error.tsx and replaces the whole page. The dialog is optional UI, so report the
// error and render nothing instead of taking the feed down with it.
function LoginDialogFallback(_props: Record<string, unknown>, { error }: ErrorInfo) {
    return <ErrorReporter error={error} />
}

// NOTE: separate component because Biome does not recognize the `(props, errorInfo)` fallback
// signature as a component and rejects hooks there.
function ErrorReporter({ error }: { error: unknown }) {
    React.useEffect(() => {
        Sentry.captureException(error)
    }, [error])

    return null
}

export const LoginDialogBoundary = catchError(LoginDialogFallback)
